export default __webpack_public_path__ + "static/media/icon-02.fcbf4c8d.svg";